import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { I18NextModule } from 'angular-i18next';
import { AumicoComponentsModule } from '../../../aumico-components/src/lib';

import { AUMICO_AI_AGENTS_CONFIG, AumicoAiAgentsConfig } from './aumico-ai-agents.config';
import { AiAgentHttpService } from './services/ai-agent-http.service';
import { AiAgentSocketService } from './services/ai-agent-socket.service';
import { AiAgentEffects } from './effects/ai-agent.effects';
import { AI_AGENT_FEATURE_KEY, aiAgentReducer } from './reducer/ai-agent.reducer';
import { AiAgentProvider } from './provider/ai-agent.provider';
import { AiFixerPanelComponent } from './components/ai-fixer-panel/ai-fixer-panel.component';
import { AiFixerProgressComponent } from './components/ai-fixer-progress/ai-fixer-progress.component';
import { AiOrgSettingsService } from './services/ai-org-settings.service';

@NgModule({
    declarations: [
        AiFixerPanelComponent,
        AiFixerProgressComponent,
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        I18NextModule,
        AumicoComponentsModule,
        StoreModule.forFeature(AI_AGENT_FEATURE_KEY, aiAgentReducer),
        EffectsModule.forFeature([AiAgentEffects]),
    ],
    exports: [
        AiFixerPanelComponent,
        AiFixerProgressComponent,
    ],
})
export class AumicoAiAgentsModule {
    static forRoot(config: AumicoAiAgentsConfig): ModuleWithProviders<AumicoAiAgentsModule> {
        return {
            ngModule: AumicoAiAgentsModule,
            providers: [
                AiAgentHttpService,
                AiAgentSocketService,
                AiAgentProvider,
                AiOrgSettingsService,
                {
                    provide: AUMICO_AI_AGENTS_CONFIG,
                    useValue: config,
                },
            ],
        };
    }
}
